import { IconLabel } from '@src/components/ui/IconLabel';
import { PasswordInput } from '@src/components/ui/PasswordInput';
import { isFormValidationError } from '@src/utilities/form';
import { InputRef } from 'antd';
import { ForwardedRef, forwardRef } from 'react';
import { ICommonFormProps } from '../DynamicForm.types';

export const FormPasswordInput = forwardRef(
    (props: ICommonFormProps, ref: ForwardedRef<InputRef>) => {
        const labelText = props.label;

        // Map antd size to our custom size
        const mapSize = (size?: 'small' | 'middle' | 'large') => {
            switch (size) {
                case 'small':
                    return 'sm';
                case 'large':
                    return 'lg';
                default:
                    return 'md';
            }
        };

        const { size, ...inputProps } = props.inputProperties || {};

        return (
            <div className="w-full">
                <PasswordInput
                    ref={ref}
                    disabled={props.disabled || false}
                    label={labelText}
                    error={
                        props.errors
                            ? isFormValidationError(props.errors.type)
                                ? props.errors?.message
                                : `${props.label} ${props.errors.type}`
                            : undefined
                    }
                    data-component-name={props.keyName}
                    className={props.className}
                    {...inputProps}
                    size={mapSize(size)}
                    placeholder={props.inputProperties?.placeholder || ''}
                    {...props.field}
                    onChange={
                        props.formProps?.onChange
                            ? (e) => {
                                  props.formProps?.onChange(e);
                                  if (props.setValue) {
                                      props.setValue(
                                          props.keyName,
                                          e.target.value
                                      );
                                      props.triggerValidation!(props.keyName);
                                  }
                              }
                            : props.field?.onChange
                    }
                    onBlur={props.formProps?.onBlur ?? props.field?.onBlur}
                    isRequired={
                        typeof props.registerOptions?.required === 'object'
                            ? Boolean(props.registerOptions.required.value)
                            : Boolean(props.registerOptions?.required)
                    }
                    defaultValue={props.formProps?.defaultValue}
                    maxLength={props.formProps?.maxLength}
                    help={props.formProps?.help}
                />
                {props.formProps?.info && (
                    <IconLabel
                        title={props.formProps?.info}
                        type={props.formProps?.infoType}
                        rootClassName="mt-3"
                    />
                )}
            </div>
        );
    }
);

FormPasswordInput.displayName = 'FormPasswordInput';
